import {Component, ElementRef, QueryList, ViewChild} from '@angular/core';
import {
  AlertController,
  App,
  Events,
  IonicPage,
  LoadingController,
  NavController,
  NavParams,
  PopoverController,
  Slides
} from 'ionic-angular';
import * as moment from "moment";
import {Subscription} from "rxjs";
import {UserStateProvider} from "../../providers/user-state/user-state";
import {UserStatsProvider} from "../../providers/user-stats/user-stats";
import {ApiUserProgressProvider} from "../../providers/api-user-progress/api-user-progress";
import {AppStepUpdatePage} from "../app-step-update/app-step-update";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";
import {StepCounterEngineProvider} from "../../providers/step-counter-engine/step-counter-engine";
import {AppMoodUpdatePage} from "../app-mood-update/app-mood-update";
import {ApiCourseDataProvider} from "../../providers/api-course-data/api-course-data";
import {AppVideoPlayerPage} from "../app-video-player/app-video-player";
import {UserProgressStateProvider} from "../../providers/user-progress-state/user-progress-state";
import {ApiProvider} from "../../providers/api/api";
import {UserTagProvider} from "../../providers/user-tag/user-tag";
import {AppSettingsGoalPage} from "../app-settings-goal/app-settings-goal";
import {AppStepCounterPage} from "../app-step-counter/app-step-counter";
import {InitStepCounterPage} from "../init-step-counter/init-step-counter";
import * as shape from "d3-shape";
import {ApiStepCounterProvider} from "../../providers/api-step-counter/api-step-counter";
/**
 * Generated class for the AppStatsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

class WeekData {
  index: number;
  start: string;
  end: string;
  label: string;
  active: boolean;
  stepsData: any;
  moodData: any;
  activityData: any;
  groupedData: any;
  groupedDataMax: number;
  stepSum: number;
  activitySum: number = 0;
  goalCnt: number;
  currentWeek: boolean;
  moodAvg: number;
  moodSum: number;
  moodCnt: number = 0;
  moodGraph: string = '';
  moodPoint: {x: number, y: number, color: string};
  gradient: Array<{x: number, y: string}>;
  startEndPoints: Array<{x: number, y: number, color: string}>;
  foodData: any;

  constructor(data: any) {
    for(var k in data) {
      this[k] = data[k];
    }
  }
}

@IonicPage()
@Component({
  selector: 'page-app-stats',
  templateUrl: 'app-stats.html',
})
export class AppStatsPage {
  @ViewChild(Slides) slides: Slides;
  @ViewChild('extraPager') pagerWrapper: ElementRef;

  weeks: Array<WeekData>;
  subscriptions: Array<Subscription>;
  activeDay: number;
  activeMoodDay: number;
  activeActivityDay: number;
  activeActivityTypeDay: number;
  activeActivityWeekly: number;
  dayLabel: Array<string> = ['M','D','M','D','F','S','S'];
  private moodDetails: Map<number, string>;
  currentMode: string;

  pageTitle: string = 'Activity';

  syncAvailable: boolean = false;
  weeklyView: boolean = false;
  todaysData: any;
  currentTarget: number = 30;

  myWayInfoTitle: string;
  myWayInfoText: string;
  graphData: Array<any> = [];

  uiDataLoaded: boolean;
  activeIndex: number;

  pauseMode: boolean;

  firstActivityMessage: {
    title: string,
    message: string
  }

  goalReachedMessage: {
    title: string,
    message: string
  }

  initActivitySum: number = 0;

  constructor(public navCtrl: NavController, public navParams: NavParams, public userState: UserStateProvider, private app: App, public userStats: UserStatsProvider, public popoverCtrl: PopoverController, public translations: ContentTranslationProvider, public stepCounterEngine: StepCounterEngineProvider, public loadingCtrl: LoadingController, public events: Events, public contentTranslation: ContentTranslationProvider, public alertCtrl: AlertController, public api: ApiProvider, public apiCourseData: ApiCourseDataProvider, public userTags: UserTagProvider, public apiStepCounter: ApiStepCounterProvider) {
    moment.updateLocale('de',function() {});

    this.subscriptions = new Array<Subscription>();
    this.moodDetails = new Map<number, string>();
    this.moodDetails.set(1, 'schlecht');
    this.moodDetails.set(2, 'nicht gut');
    this.moodDetails.set(3, 'ok');
    this.moodDetails.set(4, 'gut');
    this.moodDetails.set(5, 'super');

    let dayAfterRegistration = moment().diff(moment(this.userState.user.createdAt.substr(0, 10)), 'days')+1;
    this.api.callGet('/activity_messages/'+dayAfterRegistration).subscribe(response => {
      this.firstActivityMessage = response as {title: string, message: string};
    })
    this.api.callGet('/activity_message_goal_reacheds/'+dayAfterRegistration).subscribe(response => {
      this.goalReachedMessage = response as {title: string, message: string};
    })


    this.weeks = new Array<WeekData>();
    var today = moment();
    today.subtract(parseInt(today.format('E'))-1, 'days');
    let weekCount = 20;
    if(this.navParams.get('mode') == 'weight') {
      weekCount = 1;
    }

    for(var i = 0; i < weekCount;i++) {
      var end = today.clone();
      end.add(6,'days');
      var label = today.format('D. MMM')+' - '+end.format('D. MMM');
      if(i == 0) {
        label = 'Diese Woche';
      }
      if(i == 1) {
        label = 'Letzte Woche';
      }
      this.weeks.push(
        new WeekData({
          index: i,
          start: today.format('YYYY-MM-DD'),
          end: end.format('YYYY-MM-DD'),
          label: label,
          active: false,
          stepsData: [],
          groupedData: [],
          groupedDataMax: 10,
          moodData: [],
          activityData: [],
          currentWeek: (i==0)
        })
      )

      today.subtract(7, 'days');
    }

    this.weeks = this.weeks.reverse();

    if(this.stepCounterEngine.getEngine(this.userState.user.stepCounterEngine)) {
      this.stepCounterEngine.getEngine(this.userState.user.stepCounterEngine).syncAvailable().then((res: boolean) => {
        this.syncAvailable = res;
      })
    }


    this.events.subscribe('stats:food:update', () => {
      this.loadFoodData();
    })

    this.events.subscribe('stats:updated', (stat) => {
      console.log('stats updated', stat, this.todaysData);
      let yesterdayYmd = moment().subtract(1, 'day').format('YYYY-MM-DD');;

      if (!(window as any).statsAlertsInitialized) {
        (window as any).statsAlertsInitialized = true;
        if (stat.activityDaysCount == 3) {
          const alert = this.alertCtrl.create({
            title: this.contentTranslation.translateContent('Popup window activity day 3 title'),
            subTitle: this.contentTranslation.translateContent('Popup window activity day 3 content'),
            buttons: [
              {
                text: this.contentTranslation.translateContent('OK'),
              },
              {
                text: '×',
                cssClass: 'close-button'
              }
            ],
            cssClass: 'ip-alert ip-with-close ip-dynamic-height'
          });
          alert.present();
        } else if (stat.activityDaysCount == 5) {
          const alert = this.alertCtrl.create({
            title: this.contentTranslation.translateContent('Popup window activity day 5 title'),
            subTitle: this.contentTranslation.translateContent('Popup window activity day 5 content'),
            buttons: [
              {
                text: this.contentTranslation.translateContent('OK'),
              },
              {
                text: '×',
                cssClass: 'close-button'
              }
            ],
            cssClass: 'ip-alert ip-with-close ip-dynamic-height'
          });
          alert.present();
        }
      }
      if(stat && stat.date == this.todaysData.date) {
        if (stat.activitySum >= this.currentTarget) {
          this.events.publish('activity:goalReached');
        }
        if (this.initActivitySum < this.currentTarget && stat.activitySum >= this.currentTarget && this.goalReachedMessage) {
          const alert = this.alertCtrl.create({
            title: this.goalReachedMessage.title,
            subTitle: this.goalReachedMessage.message,
            buttons: [
              {
                text: this.contentTranslation.translateContent('OK'),
              },
              {
                text: '×',
                cssClass: 'close-button'
              }
            ],
            cssClass: 'ip-alert ip-with-close ip-dynamic-height'
          });
          alert.present();
        }
        else if(!this.initActivitySum && stat.activitySum && this.firstActivityMessage) {
          const alert = this.alertCtrl.create({
            title: this.firstActivityMessage.title,
            subTitle: this.firstActivityMessage.message,
            buttons: [
              {
                text: this.contentTranslation.translateContent('OK'),
              },
              {
                text: '×',
                cssClass: 'close-button'
              }
            ],
            cssClass: 'ip-alert ip-with-close ip-dynamic-height'
          });
          alert.present();
        }
      }

      if(stat && stat.date == moment().format('YYYY-MM-DD')) {
        this.initActivitySum = stat.activitySum;

        this.todaysData = stat;
        this.graphData = this.generateGraphData();
      }

      if(stat.date == yesterdayYmd  && !localStorage.getItem('stats_not_reached_goal_notification_'+yesterdayYmd)) {
        if(stat.activitySum > 0 && stat.activitySum < this.currentTarget) {
          this.api.callGet('/activity_message_goal_not_reacheds/'+dayAfterRegistration).subscribe(response => {
            let yesterdayGoalNotReachedMessage = response as {title: string, message: string};

            if(yesterdayGoalNotReachedMessage) {
              const alert = this.alertCtrl.create({
                title: yesterdayGoalNotReachedMessage.title,
                subTitle: yesterdayGoalNotReachedMessage.message,
                buttons: [
                  {
                    text: this.contentTranslation.translateContent('OK'),
                  },
                  {
                    text: '×',
                    cssClass: 'close-button'
                  }
                ],
                cssClass: 'ip-alert ip-with-close ip-dynamic-height'
              });
              alert.present();
            }

          })
        }
        localStorage.setItem('stats_not_reached_goal_notification_'+yesterdayYmd, '1');
      }

      this.loadUiData();
    });


    this.events.subscribe('user:updated', user => {
        console.log('user updated');

      this.currentTarget = this.userState.user.activityTarget?this.userState.user.activityTarget:30;
      this.uiDataLoaded = false;

      setTimeout(() => {
        this.uiDataLoaded = true;
      }, 50);
    });

    this.events.subscribe('app:step-counter-engine-update', user => {
      this.syncAvailable = false;
      if(this.stepCounterEngine.getEngine(this.userState.user.stepCounterEngine)) {
        this.stepCounterEngine.getEngine(this.userState.user.stepCounterEngine).syncAvailable().then((res: boolean) => {
          this.syncAvailable = res;
        })
      }

    })

  }

  abs(a: number) {
    return Math.abs(a);
  }

  formatXAxisValue(value: number) {
    return `Value ${value}`;
  }

  goBack() {
    this.navCtrl.parent.select(0);
  }

  ionViewDidLeave() {
    if(this.navParams && this.navParams.data && (this.navParams as any).data.showMotivationalMessageOnClose) {
      this.events.publish('app:show-motivational-message');
    }
  }

  generateGraphData() {
    // Create an arc generator with configuration
    var arcGenerator = shape.arc();

    var todaysData = this.todaysData?this.todaysData:{};
    let rows = [];
    let limit = (todaysData.activitySum > this.currentTarget) ? todaysData.activitySum : this.currentTarget;
    if(!todaysData.groups) {
      todaysData.groups = {};
    }

    var currentPerc = 0;
    if (todaysData.activitySum != todaysData.extraActivitySum) {
      todaysData.groups[0] = todaysData.activitySum - todaysData.extraActivitySum;
    }
    for(var k in todaysData.groups) {
      var perc = parseInt(todaysData.groups[k]) / parseInt(limit);

      var arcConfig = {
        startAngle: currentPerc*2*Math.PI,
        endAngle: (currentPerc+perc)*2*Math.PI,
        innerRadius: 80,
        outerRadius: 100
      };
      // Generate the path string
      var pathData = arcGenerator(arcConfig);

      rows.push({
        group: k,
        minutes: todaysData.groups[k],
        label: this.contentTranslation.translateContent('Activity '+k),
        shortLabel: this.contentTranslation.translateContent('Activity Short '+k),
        pathData: pathData,
        perc: perc,
        percForActivity: (todaysData.groups[k] <= this.currentTarget*1.2)?
            ((todaysData.groups[k]/this.currentTarget)*100):
            120,
        color: 'url(#gradient-activity-'+k+')'
      })
      currentPerc += perc;
      console.log(todaysData.groups[k], this.currentTarget*1.2, todaysData.groups[k] >this.currentTarget*1.2)
    }
    console.log('graph data updated', rows);
    return rows;
  }

  loadUiData() {
    this.weeks.map((week, index) => {
      week.stepsData = [];
      week.moodData = [];
      week.activityData = [];
      week.groupedData = [];
      week.groupedDataMax = 100;
      var startDate = moment(week.start);
      var promises = [];
      for (var i = 0; i < 7; i++) {
        var l = i.toString();
        promises.push(this.userStats.getUserStats(startDate.format('YYYY-MM-DD')));
        startDate.add(1, 'day');
      }

      let recentSuccessDays = 0;

      var currentTarget = this.userState.user.activityTarget ? this.userState.user.activityTarget : 30;
      this.currentTarget = currentTarget;

      Promise.all(promises).then(data => {
        var previousWeek = null;
        if (index) {
          previousWeek = this.weeks[index - 1];
        }
        for (var l in data) {
          var stat = data[l];

          if (stat.date == moment().format('YYYY-MM-DD')) {
            this.todaysData = stat;
            this.initActivitySum = this.todaysData.extraActivitySum;
            this.graphData = this.generateGraphData();
          }

          let dayDiff = moment(stat.date).diff(moment(), 'days');
          if (dayDiff >= -2 && dayDiff <= 0 && stat.activitySum >= currentTarget) {
            recentSuccessDays++;
          }

          week.stepsData[l] = {
            date: moment(stat.date).format('dd, D. MMM'),
            current: stat.steps,
            prev: (previousWeek && previousWeek.stepsData[l]) ? previousWeek.stepsData[l].current : 0
          };
          week.moodData[l] = {
            date: moment(stat.date).format('dd, D. MMM'),
            current: stat.mood,
            currentFeedback: stat.moodFeedback,
            prev: (previousWeek && previousWeek.moodData[l]) ? previousWeek.moodData[l].current : 0,
            index: l
          };

          if (stat.groups) {
            for (var sgId in stat.groups) {
              if (!week.groupedData[sgId]) {
                week.groupedData[sgId] = {val: 0, activity: sgId};
              }
              week.groupedData[sgId].val += stat.groups[sgId];
              if (week.groupedDataMax < week.groupedData[sgId].val) {
                week.groupedDataMax = Math.ceil(week.groupedData[sgId].val / 100) * 100;
              }
            }
          }

          week.activityData[l] = {
            date: moment(stat.date).format('dd, D. MMM'),
            current: stat.activitySum,
            prev: (previousWeek && previousWeek.activityData[l]) ? previousWeek.activityData[l].current : 0
          }
        }
        week.stepSum = 0;
        week.goalCnt = 0;
        week.moodCnt = 0;
        week.moodSum = 0;
        week.activitySum = 0;
        week.moodGraph = "";
        week.gradient = new Array<{ x: number, y: string }>();

        week.startEndPoints = [];

        let windowInnerWidth = 500;
        let gradientColours = [
          '#016674',
          '#037B89',
          '#06909D',
          '#08A5B2',
          '#0BBAC7',

        ]

        week.moodData.map(row => {
          if (parseInt(row.current) < 1) {
            row.current = 0;
          }
          if (row.current) {
            row.currentPerc = (row.current - 0.5) / 4 * 100;
            week.moodSum += parseFloat(row.current);
            week.moodCnt++;
            week.moodAvg = Math.round(week.moodSum / week.moodCnt);
          }
          if (row.prev) {
            row.prevPerc = (row.prev - 0.5) / 4 * 100;
          }
          row.label = this.moodDetails.get(row.current);

          if (row.current) {
            let x = (parseInt(row.index)) * windowInnerWidth * 0.1667 + 3;
            let y = 215 - (parseInt(row.current) - 1) * 52;

            if (x > 497) {
              x = 497;
            }

            week.gradient.push({x: Math.round(100 * parseInt(row.index) / 6), y: gradientColours[row.current - 1]});

            if (!week.moodGraph) {
              week.moodGraph = x + "," + y;
              week.moodPoint = {x: x, y: y + 5, color: gradientColours[row.current - 1]};
              week.startEndPoints.push({x: x, y: y, color: gradientColours[row.current - 1]});
              week.startEndPoints.push({x: x, y: y, color: gradientColours[row.current - 1]});
            } else {
              week.moodGraph += "\n" + x + "," + y;
              week.moodPoint = null;
              week.startEndPoints[1] = {x: x, y: y, color: gradientColours[row.current - 1]};

            }
          }

          return row;
        });

        var filteredGroupedData = [];
        for (var k in week.groupedData) {
          if (week.groupedData[k]) {
            filteredGroupedData.push(week.groupedData[k]);
          }
        }
        week.groupedData = filteredGroupedData;

        week.stepsData.map(row => {
          if (row.current < 0) {
            row.current = 0;
          }
          if (row.prev < 0) {
            row.prev = 0;
          }
          if (row.current) {
            week.stepSum += parseInt(row.current);
            week.goalCnt += (parseInt(row.current) >= 10000) ? 1 : 0;
          }
          if (row.current) {
            row.currentPerc = (row.current > 12000 ? 12000 : row.current) / 10000 * 100
          }
          if (row.prev) {
            row.prevPerc = (row.prev > 12000 ? 12000 : row.prev) / 10000 * 100
          }
          return row;
        });
        week.activityData.map(row => {
          if (row.current < 0) {
            row.current = 0;
          }
          if (row.prev < 0) {
            row.prev = 0;
          }
          if (row.current && parseInt(row.current) != NaN) {
            week.activitySum += parseInt(row.current);
          }
          if (row.current) {
            row.currentPerc = ((row.current > this.currentTarget * 1.2) ? this.currentTarget * 1.2 : row.current) / currentTarget * 100
          }
          if (row.prev) {
            row.prevPerc = ((row.prev > this.currentTarget * 1.2) ? this.currentTarget * 1.2 : row.prev) / currentTarget * 100
          }
          return row;
        });
      })
    });
    this.uiDataLoaded = true;
    this.graphData = this.generateGraphData();

    let recentStats = this.userStats.getRecentStats(2);
    if (recentStats.length === 2) {
      if (recentStats[1].activitySum > 0 && recentStats[0].activitySum - 30 > recentStats[1].activitySum) {
        this.events.publish('stats:activityLongerThanYesterday')
      }

      if (parseInt(recentStats[0].activitySum) - parseInt(recentStats[1].activitySum) > 10) {
        this.events.publish('stats:activityLongerThanYesterday10')
      }
      if (parseInt(recentStats[0].steps) - parseInt(recentStats[1].steps) >= 3000) {
        this.events.publish('stats:stepsIncreased3000')
      }
      if (parseInt(recentStats[0].steps) - parseInt(recentStats[1].steps) >= 5000) {
        this.events.publish('stats:stepsIncreased5000')
      }
    }

    this.userStats.getRecentStats(7).map(day => {
      if (!day) {
        return ;
      }
      if (day.steps >= 5000) {
        this.events.publish('stats:steps5000')
      }
      if (day.steps >= 10000) {
        this.events.publish('stats:steps10000')
      }
    })

    if (this.userStats.getRecentStats(7).filter(day => {
      return day && day.activitySum > 0
    }).length == 7) {
      this.events.publish('stats:activityFilledNDaysInRow', {days: 7})
    }
  }

  ngAfterViewInit() {
    this.loadUiData();

    this.subscriptions.push(this.slides.ionSlideWillChange.subscribe(($event) => {
      this.activeDay = null;
      this.activeMoodDay = null;
      var previousIndex = this.slides.getPreviousIndex();
      var activeIndex = this.slides.getActiveIndex();
      this.activeIndex = this.slides.getActiveIndex();
      if(activeIndex >= this.weeks.length) {
        return ;
      }
      if(this.weeks[previousIndex]) {
        this.weeks[previousIndex].active = false;
      }
      this.weeks[activeIndex].active = true;
      let pageLength = 200;
      if((window as any).innerWidth <= 320) {
        pageLength = 140;
      }
      this.pagerWrapper.nativeElement.style.marginLeft = (activeIndex*pageLength*-1+((document.body.offsetWidth-pageLength)/2))+'px';
    }));

    console.log('ngAfterInitView', new Date().toISOString());
  }

  ionViewWillEnter() {
    this.currentMode = this.navParams.get('mode');
    if(!this.userState.user.stepCounterEngine && this.currentMode == 'activity') {
      // switch user to manual step counter by default
      this.apiStepCounter.createSession('manual');
      this.userState.user.stepCounterEngine = 'manual';
      // this.app.getRootNav().push(InitStepCounterPage);
    }
  }

  ionViewDidLoad() {
    this.userStats.getStepArchive().then(data => {
      this.loadUiData();
    });
    this.loadFoodData();
  }

  ionViewDidEnter() {
    if (this.navParams.get('mode') == 'all') {
      this.pageTitle  ='Activity-Overview'
    }
    if (this.navParams.get('mode') == 'mood') {
      this.pageTitle  ='Activity-Mood'
    }
    if (this.navParams.get('mode') == 'weight') {
      this.pageTitle  ='Activity-Weight'
    }


    let todaysDate = new Date().toISOString().substr(0, 10);

    if (this.userState.user.pauseStartDate && this.userState.user.pauseStartDate.substring(0, 10) <= todaysDate && this.userState.user.pauseEndDate >= todaysDate) {
      this.pauseMode = true;
      let endDateText = moment(this.userState.user.pauseEndDate).format('DD.MM.YYYY');
      console.log(endDateText);
      this.myWayInfoTitle = this.contentTranslation.translateContent('Stats My Way Pause Title');
      this.myWayInfoText = this.contentTranslation.translateContent('Stats My Way Pause Text').replace('{date}', endDateText);
    } else {
      this.pauseMode = false;
    }

    if (!this.pauseMode) {
      this.apiCourseData.getMyWayCourses().then(courses => {
        let lastCourse = null;
        for(let k in courses) {
          if(courses[k]._userStatus == 3) {
            lastCourse = courses[k];
          }
        }

        if(lastCourse && lastCourse.myWayActivityTitle && lastCourse.myWayActivityText) {
          this.myWayInfoTitle = lastCourse.myWayActivityTitle;
          this.myWayInfoText = this.userTags.compile(lastCourse.myWayActivityText, {});

          if (this.myWayInfoText.indexOf('{')> -1) {

            this.myWayInfoTitle = lastCourse.myWayActivityFallbackTitle;
            this.myWayInfoText = lastCourse.myWayActivityFallbackText;
          }

        } else {
          this.myWayInfoTitle = this.contentTranslation.translateContent('Activity VIDEA Start')+' '+moment(this.userState.user.createdAt).format('MMMM YYYY')
          this.myWayInfoText = this.contentTranslation.translateContent('Activity VIDEA Start Text')
        }
      })
    }
  }

  loadFoodData() {
    this.api.callGet('/food').subscribe((response: any) => {
      let foodAssoc = [];
      for(let item of response) {
        foodAssoc[item.date] = item;
      }
      this.weeks.map((week) => {
        let foodData = {data: [[],[],[]]};
        let start = moment(week.start);
        for(let i = 0; i < 7; i++) {
          if(foodAssoc[start.format('YYYY-MM-DD')]) {
            let item = foodAssoc[start.format('YYYY-MM-DD')];
            foodData['data'][0][i] = parseInt(item.groupWater) + parseInt(item.groupVegetables) + parseInt(item.groupFruit) + parseInt(item.groupGrainProducts);
            foodData['data'][1][i] = parseInt(item.groupMilkProducts) + parseInt(item.groupMeatEgg);
            foodData['data'][2][i] = parseInt(item.groupOilFat) + parseInt(item.groupSnacks);
          } else {
            foodData['data'][0][i] = null;
            foodData['data'][1][i] = null;
            foodData['data'][2][i] = null;
          }
          start.add(1, 'day');
        }
        week.foodData = foodData;
      });
    });
  }

  formatTitle(val) {
    return [' ', Math.round(val*this.currentTarget/100)];
  }

  formatSubtitle(val) {
    return ['Aktivitätsminuten', 'heute'];
  }

  goToSlide(slide) {
    this.slides.slideTo(this.weeks.indexOf(slide));
  }

  openStepUpdate(openSteps:boolean = false) {
    this.app.getRootNav().push(AppStepUpdatePage, {date: moment().format("YYYYMMDD"), steps: openSteps})
  }

  openMoodUpdate() {
    this.app.getRootNav().push(AppMoodUpdatePage, {date: moment().format("YYYYMMDD")})
  }

  sync() {
    if(!this.syncAvailable) {
      return ;
    }

    var loader = this.loadingCtrl.create({
      content: this.contentTranslation.translateContent('Syncing')
    });
    loader.present();

    var startDate = moment().subtract(14,'days');
    if(startDate.format("YYYY-MM-DD") < this.userState.user.createdAt.substring(0, 10)) {
      startDate = moment(this.userState.user.createdAt.substring(0, 10));
    }

    let uiUpdateSemaphore = null;

    this.stepCounterEngine.getEngine(this.userState.user.stepCounterEngine).makeDateRangeSync(startDate.format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')).then(res => {
      if(uiUpdateSemaphore) {
        clearTimeout(uiUpdateSemaphore);
      }
      uiUpdateSemaphore = setTimeout(() => {
        this.loadUiData();
      }, 1000);
      loader.dismissAll();
    }).catch(err => {
      console.log(err)
      loader.dismissAll();
    })
  }

  min(val1, val2) {
    return Math.min(val1, val2);
  }

  formatDate(date) {
    return moment(date).format('DD.MM.YYYY')
  }

}



// WEBPACK FOOTER //
// ./src/pages/app-stats/app-stats.ts